<template>
    <div class="account-menu">
        <div class="account-menu__row">
            <div class="account-menu__column">
                <div class="balance-type">{{ `${$t('real')} ${$t('currencyAbbreviation')}` | capitalize }}</div>
                <div class="amount">{{ formattedBalance }}</div>
            </div>
            <div class="account-menu__column">
                <div class="balance-type">{{ `${$t('bonus')} ${$t('currencyAbbreviation')}` | capitalize }}</div>
                <div class="amount">{{ formattedBonus }}</div>
            </div>
        </div>
        <div class="notifications">
            <div
                v-for="notification in notifications"
                :key="notification.type"
                class="notification"
            >
                <i class="icon icon--sm icon-dot_circle" />
                <div
                    @click="$emit('notificationClick', notification.type)"
                    class="text"
                >
                    {{ $t(notification.title) | capitalize }}
                </div>
            </div>
        </div>
        <div class="actions">
            <div class="action">
                <i class="icon icon--sm icon-user" />
                <router-link
                    tag="div"
                    :to="{ name: routeNames.profile }"
                >
                    {{ $t('your account') | capitalize }}
                </router-link>
            </div>
            <div class="action">
                <i class="icon icon--sm icon-ticket_2" />
                <router-link
                    tag="div"
                    :to="{ name: routeNames.tickets }"
                >
                    {{ $t('my tickets') | capitalize }}
                </router-link>
            </div>
            <div class="action">
                <i class="icon icon--sm icon-transactions" />
                <router-link
                    tag="div"
                    :to="{ name: routeNames.history }"
                >
                    {{ $t('history') | capitalize }}
                </router-link>
            </div>
        </div>
        <div class="bottom-row">
            <div class="authenticated-for">
                {{ $t('authenticated for') | capitalize }}
                {{ sessionLength | absoluteTime }}
            </div>
            <button
                @click="$emit('logout')"
                class="btn btn__outline--white btn--sm"
            >
                {{ $t('logout') | capitalize }}
            </button>
        </div>
    </div>
</template>

<script>
    import { routeNames } from '@app/router';
    import { currency } from '@shared/filters';

    export default {
        props: {
            notifications: {
                type: Array,
                default: () => ([]),
            },
            balance: {
                type: Number,
                required: false,
                default: null
            },
            bonus: {
                type: Number,
                required: false,
                default: null
            },
            sessionLength: {
                type: Number,
                required: true,
            }
        },
        computed: {
            formattedBalance() {
                return this.balance ? currency(this.balance) : '-';
            },
            formattedBonus() {
                return this.bonus ? currency(this.bonus) : '-';
            }
        },
        created() {
            this.routeNames = routeNames;
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Account/AccountMenu.vue